
import { mapGetters } from 'vuex'

export default {
    head () {
        return {
            title: 'DC',
            link: [
                { rel: 'icon', type: 'image/x-icon', href: require('~/assets/images/favicon.png') }
            ],
        }
    },
    mounted () {
        window.addEventListener('resize', this.updateActiveBreakpoint)
    },
    // Each layout change mounts a new layout; a listener left behind kept the
    // old one alive with the page it held (2026-10-22, see mixins/survey-form.js).
    beforeDestroy () {
        window.removeEventListener('resize', this.updateActiveBreakpoint)
    },
    methods: {
        updateActiveBreakpoint () {
            this.$store.dispatch('updateActiveBreakpoint')
        },
    },
    computed: {
        ...mapGetters(['support', 'isAgentMode', 'support'])
    },
}
